<template>
<div class="login">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <img src="@/assets/DIDTrackLogo.png" height="150px"/>
            <v-card class="elevation-12">
              <v-toolbar dark color="blue">
                <v-toolbar-title>Login</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form @keyup.native.enter="login">
                  <p v-if="email.includes('asctech.net')" color="success" class="subheading">Welcome back, {{this.email}}</p>
                  <v-text-field
                      v-model="email"
                      label="Email"
                      required
                    >
                    </v-text-field>

                    <v-text-field
                      v-model="password"
                      label="Password"
                      :append-icon="show1 ? 'visibility_off' : 'visibility'"
                      :type="show1 ? 'text' : 'password'"
                      hint="Enter your password"
                      counter
                      @click:append="show1 = !show1"
                    >
                    </v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn type="login" block dark v-on:click="login" color="blue">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import firebase from 'firebase';
export default {
  name: 'login',
  data: function() {
    return {
      show1: false,
      email: '',
      password: ''
    };
  },
  created () {

  },
  methods: {
    login: function(e) {
      firebase
      .auth()
      .signInWithEmailAndPassword(this.email, this.password)
      .then(
        user => {
        this.$router.go({path: this.$router.path});
      },
      err => {
        alert(err.message);
      }
      );

      e.preventDefault();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue